/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { MdArrowDropUp, MdArrowDropDown } from 'react-icons/md';
import { toast } from 'react-toastify';
import { Form, Input } from '@rocketseat/unform';
import { useSelector } from 'react-redux';
import { Container, Card, Info, Loader } from './styles';
import history from '~/services/history';

import api from '~/services/api';
import apiBearer from '~/services/apiBearer';
import apiWSCOM from '~/services/apiWSCOM';

export default function MyAds() {

  const token = useSelector(state => state.auth.token);
  apiBearer.defaults.headers.Authorization = `Bearer ${token}`;

  // #region Attributes
  const property = useSelector(state => state.property.property);
  const [fullproperty, setFullproperty] = useState('');
  const [loader, setLoader] = useState(true);
  const [idTitleOpened, setIdTitleOpened] = useState(1);
  const [description, setDescription] = useState('');
  const [views, setViews] = useState(0);
  const [visits, setVisits] = useState(0);
  const name = useSelector(state => state.auth.document.nome);
  // #endregion

  // #region Functions
  useEffect(() => {



    apiBearer.get("/api/v1/WSListaImovel?referencia=" + property.reference).then(
      response => {
        if (typeof response.data.conteudo != "undefined" && response.data.conteudo != null) {
          setFullproperty(response.data.conteudo[0])
        }
      },
      error => {
        toast.error('Erro interno, por favor tente novamente mais tarde.');
        console.error(error);
      }
    );

    function loadDescriptive() {
      if (!property || property.reference === 0) return;

      setLoader(true);
      api
        .post('api/v1/WSImovelLocacao', {
          referencia: property.reference,
        })
        .then(
          response => {
            const {
              sucesso: success,
              mensagem: message,
              conteudo: content,
            } = response.data;

            if (success) setDescription(content[0].descricao);
            else toast.error(message);
          },
          error => {
            toast.error('Erro interno, por favor tente novamente mais tarde.');
            console.error(error);
          }
        )
        .then(() => {
          setLoader(false);
        });
    }

    function loadViews() {
      if (!property || property.reference === 0) return;

      apiBearer
        .get(`api/v1/WSVisitasImovel?referencia=${property.reference}`)
        .then(
          response => {
            const { sucesso: success, conteudo: scontent } = response.data;

            if (success) {
              setViews(scontent.visualizacoes);
              setVisits(scontent.visitas);
            }
          },
          error => {
            toast.error('Erro interno, por favor tente novamente mais tarde.');
            console.error(error);
          }
        )
        .then(() => {
          setLoader(false);
        });
    }

    loadDescriptive();
    loadViews();
    setLoader(false);
  }, [property, property.reference]);

  function handleSubmitChange() {
    setLoader(true);


    let franquiaEmail = property.email

    let franquiasCustomMail = {
      'Assessoria Imobiliária Cons.Laurindo Ltda':'disponiveis@apolarcentroaluga.com.br',
      'Image Participações S/A Centro':'disponiveis@apolarcentroaluga.com.br',
      'Image Participações S/A Araucária':'cristiane.blati@apolararaucariaaluga.com.br',
      'Mkj Imóveis Ltda':'franciscley.belasque@apolarpinhaisaluga.com.br',
      'Novo Sol Assessoria Imobiliária Ltda':'alesson.silva@apolarpersonnalite.com.br'
    }

    if (typeof franquiasCustomMail[fullproperty.nomeFranquia] != "undefined" ) {
      franquiaEmail = franquiasCustomMail[fullproperty.nomeFranquia]
    }

    apiWSCOM
      .post('api/email', {
        Destinatario: franquiaEmail,
        Subject: 'Solicitação de troca de descritivo',
        EmailBody: `Nome do solicitante: ${name}<br /> Referencia do imóvel: ${property.reference}<br /> Descritivo: ${description}`,
      })
      .then(
        response => {
          const { sucesso: success, mensagem: message } = response.data;

          if (success) {
            history.push({
              pathname: '/SolicitaçãoEnviada',
              state: {
                sBusinessId: property.businessId,
                sReference: property.reference,
                sAddress: property.address,
                sTopic: 'Meus Anúncios',
              },
            });
          } else {
            toast.error(message);
          }
        },
        error => {
          toast.error('Erro interno, por favor tente novamente mais tarde.');
          console.error(error);
        }
      )
      .then(() => {
        setLoader(false);
      });
  }

  function openAds() {
    window.open('https://www.apolar.com.br/?ref=' + property.reference);
  }
  // #endregion

  return (
    <Container>
      <Loader style={{ display: loader ? 'block' : 'none' }} />

      <div className="header">
        <h1>{property.topic}</h1>
        <div>
          <span>Ref.: {property.reference}</span>
          <span>Nº do negócio: {property.businessId}</span>
          <span>{property.address}</span>
        </div>
      </div>
      <Form onSubmit={() => handleSubmitChange()}>
        <Card>
          <div>
            <span>DESCRITIVO</span>

            {idTitleOpened ? (
              <MdArrowDropUp size={40} onClick={() => setIdTitleOpened(0)} />
            ) : (
              <MdArrowDropDown size={40} onClick={() => setIdTitleOpened(2)} />
            )}
          </div>

          {idTitleOpened ? (
            <Input
              name="description"
              value={description}
              multiline
              cols="20"
              rows="15"
              onChange={e => {
                setDescription(e.target.value);
              }}
            />
          ) : (
            ''
          )}
        </Card>
        <div className="request">
          <button type="submit" className="button">
            Solicitar alteração
          </button>
        </div>
      </Form>

        <div className="viewads" style={ ['Disponivel','Disponível','Chave Emprestada','Reservado'].indexOf(property.situacao) == -1 ? {display:'none'} : {display:'block'}} >
          <button className="button" onClick={() => openAds()}>
            Anúncio
          </button>
        </div>
    </Container>
  );
}
